import { useEffect, useState } from "react";
import { Plus, X } from "react-feather";
import styles from "../tour.module.css";
import { Autocomplete, Box, Button, Checkbox, Chip, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, OutlinedInput, Paper, Select, TextField } from "@mui/material";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddTourTileSlot from "../../prospect/Components/AddTourTileSlot";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import Loader from "../../../components/Loader";
import StepOneForm from "../../prospect/Components/AddProspect/StepOneForm";
import StepTwoForm from "../../prospect/Components/AddProspect/StepTwoForm";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const OpenTourFrom = (props) => {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [selectedTourTime, setSelectedTourTime] = useState("");
  const [selectedTourDate, setSelectedTourDate] = useState(dayjs());
  const [tourTimeSlotError, setTourTimeSlotError] = useState("");
  const [selectProperty, setSelectProperty] = useState("");
  const [propertyError, setPropertyError] = useState("");
  const [allProspectsList, setAllProspectsList] = useState([]);
  const [prospectsList, setProspectsList] = useState([]);
  const [selectedProspect, setSelectedProspect] = useState([]);
  const [prospectError, setProspectError] = useState("");
  const [addPropspectForm, setAddPropspectForm] = useState(false);
  const [addFormStep, setAddFormStep] = useState(1);
  const [stepOneData, setStepOneData] = useState(null);
  const [editId, setEditId] = useState(0);
  const [allApartmentList, setAllApartmentList] = useState([]);
  const [apartmentList, setApartmentList] = useState([]);
  const [propertytList, setPropertytList] = useState([]);
  const [selectApartment, setSelectApartment] = useState("");
  const [aptError, setAptError] = useState("");

  useEffect(() => {
    const fetchAllPropects = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospect-list-tour", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        setAllProspectsList(response.data.data);
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
      });
    };
    fetchAllPropects();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    const fetchAllApartments = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/all-apartments", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        setAllApartmentList(response.data.data);
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
      });
    };
    fetchAllApartments();
  }, [getAccessTokenSilently]);


  useEffect(() => {
    let propertytListTemp = [];
    if (allApartmentList?.length > 0) {
      propertytListTemp = props?.allProperties?.map(i => {
        let apartmentListTemp = allApartmentList?.filter(j => j?.property_id === i?.value);
        return { ...i, no_of_child: apartmentListTemp?.length };
      });
    } else {
      propertytListTemp = props?.allProperties?.map(i => {
        return { ...i, no_of_child: 0 };
      });
    }
    setPropertytList(propertytListTemp);
  }, [props?.allProperties, allApartmentList]);

  useEffect(() => {
    if (props.is_edit) {
      let date_time = props.selectedEvent?.extendedProps?.date_time;
      let dateArr = date_time.split(" ");
      setSelectedTourDate(dayjs(dateArr[0]));
      setSelectedTourTime(dateArr[1]);
      setSelectProperty(props.selectedEvent?.extendedProps?.property_id);
      setSelectApartment(props.selectedEvent?.extendedProps?.apt_id);
      setEditId(props.selectedEvent?.extendedProps?.tour_id);

      let selPros = allProspectsList.filter(
        (i) => i.id === props.selectedEvent?.extendedProps?.prospect_id
      );
      setSelectedProspect(selPros);
    } else {
      setSelectedTourDate(props.defaultDate);
    }
  }, [props.is_edit, props.selectedEvent, allProspectsList, props.defaultDate]);

  useEffect(() => {
    if (props.selectedProperty > 0) {
      setSelectProperty(props.selectedProperty);
    }
  }, [props.selectedProperty]);

  useEffect(() => {
    let apartmentListTemp = [];
    if (selectProperty) {
      apartmentListTemp = allApartmentList?.filter(i => i?.property_id === selectProperty);
    }

    setApartmentList(apartmentListTemp);
  }, [allApartmentList, selectProperty]);

  useEffect(() => {
    if (selectProperty !== "") {
      let pList = allProspectsList?.map((i) => {
        if (i?.property_id === selectProperty) {
          return i;
        }
        return null;
      });

      pList = pList.filter((i) => i !== null);

      setProspectsList(pList);
    }
  }, [allProspectsList, selectProperty]);

  useEffect(() => {
    if (selectedTourTime !== "") {
      setTourTimeSlotError("");
    }
  }, [selectedTourTime]);

  useEffect(() => {
    if (selectProperty !== "") {
      setPropertyError("");
    }
  }, [selectProperty]);

  useEffect(() => {
    if (selectApartment !== "") {
      setAptError("");
    }
  }, [selectApartment]);

  useEffect(() => {
    if (selectedProspect.length > 0) {
      setProspectError("");
    }
  }, [selectedProspect]);

  const onSubmit = async () => {
    if (selectProperty === "") {
      setPropertyError("Please select property.");
      return false;
    }

    if (selectApartment === "") {
      setAptError("Please select apartment.");
      return false;
    }
    if (selectedProspect.length === 0) {
      setProspectError("Please select prospect.");
      return false;
    }
    if (selectedTourTime === "") {
      setTourTimeSlotError("Please select time slot.");
      return false;
    }

    let prospectIds = selectedProspect?.map((i) => {
      return i?.id;
    });

    let postData = { property_id: selectProperty, apt_id: selectApartment, prospect_ids: prospectIds, date_time: dayjs(selectedTourDate).format("YYYY-MM-DD") + " " + selectedTourTime };
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    setLoading(true);

    axios.post(process.env.REACT_APP_APPLICANT_API_URL + "v1/add-tour", postData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((response) => {
      setLoading(false);
      props.setAddTourFormOpen(false);
      props.setSnackbarMsg(response.data.message);
      props.setSnackbarOpen(true);

      props.onSubmit(response.data.data);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  const onSubmitOne = (data) => {
    setAddFormStep(2);
    setStepOneData(data);
  };

  const onSubmitTwo = async (data) => {
    let postData = {};
    postData = { ...postData, ...stepOneData };
    if (typeof data.credit_score !== "undefined") {
      postData = { ...postData, credit_score: data.credit_score };
    }
    if (typeof data.have_pets !== "undefined") {
      postData = { ...postData, have_pets: data.have_pets };
    }
    if (typeof data.income_per_year !== "undefined") {
      postData = { ...postData, income_per_year: data.income_per_year };
    }
    if (typeof data.bedrooms !== "undefined") {
      postData = { ...postData, bedrooms: data.bedrooms };
    }
    if (typeof data.move_in_date !== "undefined") {
      postData = { ...postData, move_in_date: dayjs(data?.move_in_date).format("YYYY-MM-DD HH:mm:ss") };
    }
    if (typeof data.bathrooms !== "undefined") {
      postData = { ...postData, bathrooms: data.bathrooms };
    }
    if (typeof data.do_you_smoke !== "undefined") {
      postData = { ...postData, do_you_smoke: data.do_you_smoke };
    }

    setAddPropspectForm(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    await axios.post(process.env.REACT_APP_APPLICANT_API_URL + "v1/add-prospect", postData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((response) => {
      setLoading(false);

      let newData = response.data.data;

      setAllProspectsList((prev) => {
        return prev.concat([newData]);
      });

      setSelectedProspect((prev) => {
        return prev.concat([newData]);
      });
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  };

  const onUpdate = async () => {
    if (selectApartment === "") {
      setAptError("Please select apartment.");
      return false;
    }

    let postData = { apt_id: selectApartment, date_time: dayjs(selectedTourDate).format("YYYY-MM-DD") + " " + selectedTourTime };
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    setLoading(true);

    axios.put(process.env.REACT_APP_APPLICANT_API_URL + "v1/tour/" + editId, postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);
      props.setAddTourFormOpen(false);
      props.setSnackbarMsg(response.data.message);
      props.setSnackbarOpen(true);

      props.onSubmit(response.data.data);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  return (<>
    {loading && <Loader />}
    {!addPropspectForm && (<>
      <DialogTitle id="alert-dialog-title">
        {props?.is_edit ? "Edit" : "Add"} Tour
        <button onClick={(e) => props.setAddTourFormOpen(false)}>
          <X />
        </button>
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          <div className={`${styles.Width100}`}>
            <div className={`${styles.PopupFilterRow}`}>
              <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter AddTour`}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Property Name*</InputLabel>
                  <Select
                    input={<OutlinedInput label="Property Name" />}
                    MenuProps={MenuProps}
                    onChange={(e) => {
                      setSelectProperty(e.target.value);
                      setSelectedProspect([]);
                      setSelectApartment("");
                    }}
                    value={selectProperty}
                    disabled={props?.is_edit}
                  >
                    {propertytList?.map((item) => {
                      return (<MenuItem key={item?.value} value={item?.value} disabled={(item?.no_of_child === 0) ? true : false}>{item?.label}</MenuItem>);
                    })}
                  </Select>
                </FormControl>
                {propertyError !== "" && (<p className={`${styles.AddTourErrorMessage}`}>{propertyError}</p>)}
              </div>

              <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter AddTour`}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Apartment*</InputLabel>
                  <Select
                    input={<OutlinedInput label="Apartment" />}
                    MenuProps={MenuProps}
                    onChange={(e) => setSelectApartment(e.target.value)}
                    value={selectApartment}
                  >
                    {apartmentList?.map((item) => {
                      return (<MenuItem key={item?.id} value={item?.id}>{item?.apt_no}</MenuItem>);
                    })}
                  </Select>
                </FormControl>
                {aptError !== "" && (<p className={`${styles.AddTourErrorMessage}`}>{aptError}</p>)}
              </div>

              <div className={`${styles.FilterCard} ${styles.Full} ${styles.Select} CusSelectFilter AddTour AutoCom`}>
                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    options={prospectsList}
                    disableCloseOnSelect
                    disableClearable
                    getOptionLabel={(value) => value?.full_name + " - " + value?.phone}
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      return (
                        <li key={key} {...optionProps} className={`${styles.ABCD}`}>
                          <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.full_name} - {option.phone}
                        </li>
                      );
                    }}
                    style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField {...params} label="Prospect's Name*" />
                    )}
                    onChange={(e, newValue) => {
                      setSelectedProspect(newValue);
                    }}
                    value={selectedProspect}
                    PaperComponent={({ children }) => {
                      return (
                        <Paper>
                          {children}
                          <Button
                            color="primary"
                            fullWidth
                            sx={{ justifyContent: "flex-start", pl: 2 }}
                            className={`${styles.AddProspectBUPop}`}
                            onMouseDown={() => {
                              setAddPropspectForm(true);
                              setAddFormStep(1);
                            }}
                          >
                            <Plus />New Prospect
                          </Button>
                        </Paper>
                      );
                    }}
                    disabled={props?.is_edit}
                  />
                </FormControl>
                {prospectError !== "" && (<p className={`${styles.AddTourErrorMessage}`}>{prospectError}</p>)}
              </div>
            </div>

            <p className={`${styles.AddTourPopTT}`}>Select Tour Date and Time</p>
            <div className={`${styles.ModalFormGroup} ModalFormGroup`}>
              <div className={`${styles.AddTourModal} AddTourModal`}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <StaticDatePicker
                    orientation="landscape"
                    value={selectedTourDate}
                    onChange={(e) => setSelectedTourDate(e)}
                  />
                </LocalizationProvider>
              </div>
              <div className={`${styles.AddTourTimeArea}`}>
                <p className={`${styles.TimeSlotTitle}`}>{dayjs(selectedTourDate).format("dddd, MMMM D")}</p>
                <p className={`${styles.AddTourErrorMessage}`}>{tourTimeSlotError !== "" && tourTimeSlotError}</p>
                <AddTourTileSlot
                  setSelectedTourTime={setSelectedTourTime.bind(this)}
                  selectedTourTime={selectedTourTime}
                  selectedTourDate={selectedTourDate}
                  selectProperty={selectProperty}
                />
              </div>
            </div>
          </div>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={(e) => props.setAddTourFormOpen(false)} className="CancelPopupBU">Cancel</Button>
        {!props?.is_edit && (<Button className="SubmitPopupBU" onClick={onSubmit}>Add</Button>)}
        {props?.is_edit && (<Button className="SubmitPopupBU" onClick={onUpdate}>Update</Button>)}
      </DialogActions>
    </>)}
    {addPropspectForm && addFormStep === 1 && (<StepOneForm
      setOpenAddProspectModal={setAddPropspectForm.bind(this)}
      onSave={onSubmitOne.bind(this)}
      selectedProperty={selectProperty}
    />)}

    {addPropspectForm && addFormStep === 2 && (<StepTwoForm
      setOpenAddProspectModal={setAddPropspectForm.bind(this)}
      onSave={onSubmitTwo.bind(this)}
      onSubmit={onSubmitTwo.bind(this)}
      isTourOption={false}
    />)}
  </>);
};

export default OpenTourFrom;
